module.exports = __webpack_public_path__ + "img/point.ecc59f86.png";